import React from 'react';

export function DeleteIcon({ size = '16px', color = '#ccc' }) {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 512.000000 512.000000"
      preserveAspectRatio="xMidYMid meet"
    >
      <g
        transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
        fill={color}
        stroke="none"
      >
        <path
          d="M1338 4086 c-31 -13 -72 -36 -91 -52 -42 -35 -978 -1162 -1012 -1219
-13 -22 -32 -69 -41 -105 -19 -74 -10 -156 24 -232 20 -44 949 -1307 1004
-1365 17 -17 58 -47 92 -65 l61 -33 1650 0 1650 0 57 28 c72 35 149 119 180
195 l23 57 0 1265 0 1265 -23 57 c-31 76 -105 156 -179 193 l-58 30 -1640 2
-1640 3 -57 -24z m3232 -1526 l0 -1190 -1544 0 -1545 0 -466 630 -466 630 463
560 463 560 1547 0 1548 0 0 -1190z"
        />
        <path
          d="M2670 3193 c-29 -11 -89 -64 -109 -97 -14 -22 -21 -50 -21 -81 l0
-48 202 -203 202 -204 -202 -204 -202 -203 0 -50 c0 -62 37 -119 103 -157 47
-28 80 -32 123 -15 16 5 116 97 224 204 l196 195 194 -195 c214 -214 235 -229
309 -207 44 14 126 96 137 136 17 68 3 88 -209 297 l-202 199 202 199 c212
209 226 229 209 297 -11 40 -93 122 -137 136 -74 22 -95 7 -309 -207 l-194
-195 -196 195 c-108 107 -208 199 -224 204 -29 12 -71 13 -96 4z"
        />
      </g>
    </svg>
  );
}